const colorSet = {
  primary100: '#F4F8FF',
  primary200: '#E9F1FF',
  primary300: '#CADDFF',
  primary400: '#8EB7FF',
  primary500: '#4B88FF',
  primary600: '#125CED',
  primary700: '#094BCA',
  primary800: '#1042A3',
  primary900: '#12367C',
  primary1000: '#1A2A4A',
  successBackGround: '#22c2450a',
  successLight: '#E8F5E9',
  successBase: '#8AD78D',
  successMain: '#22C245',
  successDark: '#06A228',
  errorLight: '#fce7e7',
  errorBase: '#F88B88',
  errorMain: '#e53935',
  errorDark: '#c62828',
  errorBackGround: '#e539350a',
  warningLight: '#FFF1C8',
  warningBase: '#FFDA6B',
  warningMain: '#FFC107',
  warningDark: '#FFA000',
  warningBackGround: '#ffc1070a',
  gray000: '#ffffff',
  gray100: '#F8F9FA',
  gray200: '#F1F3F5',
  gray300: '#E9ECEF',
  gray400: '#DEE2E6',
  gray500: '#CED4DA',
  gray600: '#ADB5BD',
  gray700: '#868E96',
  gray800: '#495057',
  gray900: '#343A40',
  gray1000: '#212529',
  gray2000: '#000000',
  backgroundLight: '#F8F9FA',
  backgroundBase: '#e5e5e5',
  backgroundDark: '#c2c2c2'
};

export default colorSet;
